export default __webpack_public_path__ + "static/media/ic-time.4f31ae6f.svg";